import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {of} from 'rxjs';

interface IExportListItem {
  exportId: number;
  displayFileName: string;
  actualFileName: string;
  createdDate: string;
  fileStatus: string;
}

export {
  IExportListItem
};

@Injectable({
  providedIn: 'root'
})
export class ExportsPanelService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    })
  };

  constructor(private _http: HttpClient) {}

  getList() {
    return this._http.get("/irebalone/async/file/exports", this.httpOptions);
  }

  download(exportId: string) {
    return this._http.get("/irebalone/async/file/exports/" + exportId, { responseType: 'blob' });
  }
}